import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useSelector, useDispatch } from "react-redux";

import Login from "./screens/Login/Login";
import ForgotPass from "./screens/ForgotPassword/ForgotPass";
import PublicRoutes from "./auth/PublicRoutes";
import ProtectedRoutes from "./auth/ProtectedRoutes";
import LoadingLoader from "./components/LoadingLoader";
import { validateToken } from "./redux/user/user.actions";
import Newlead from "./screens/NewLead/Newlead";
import Subscription from "./screens/Subscription/Subscription";
import Personel from "./screens/Personel/Personel";
import MasterPricing from "./screens/MasterPricing/MasterPricing";
import SchedulingModal from "./screens/SchedulingModal/SchedulingModal";
import ProposalText from "./screens/Proposal_Text";
import Notification from "./screens/Notifications/Notification";
import Help from "./screens/Help/Help";
import Setup from "./screens/Setup/Setup";
import ClientEmailTemplate from "./screens/ClientEmailTemplate/ClientEmailTemplate";
import Tax from "./screens/Tax/Tax";
import SubscriptionManagement from "./screens/SubscriptionManagement/SubscriptionManagement";
import RepairPolicy from "./screens/RepairPolicy";
function AppRoute() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(validateToken(() => setLoading(false)));
  }, [dispatch]);

  if (loading) {
    return <LoadingLoader />;
  }

  return (
    <div>
      <ToastContainer />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <PublicRoutes>
            <Login />
          </PublicRoutes>
        } />
        <Route path="/forgotpassword/:email/:otp" element={
          <PublicRoutes>
            <ForgotPass />
          </PublicRoutes>
        } />
        
        {/* Protected Routes */}
        <Route path="/first-time-setup" element={
          <ProtectedRoutes>
            <Setup />
          </ProtectedRoutes>
        } />
        <Route path="/newleads" element={
          <ProtectedRoutes>
            <Newlead />
          </ProtectedRoutes>
        } />
        <Route path="/subscription" element={
          <ProtectedRoutes>
            <Subscription />
          </ProtectedRoutes>
        } />
        <Route path="/supplier-personnel" element={
          <ProtectedRoutes>
            <Personel />
          </ProtectedRoutes>
        } />
        <Route path="/master-pricing" element={
          <ProtectedRoutes>
            <MasterPricing />
          </ProtectedRoutes>
        } />
        <Route path="/scheduling-modal" element={
          <ProtectedRoutes>
            <SchedulingModal />
          </ProtectedRoutes>
        } />
        <Route path="/proposal-text" element={
          <ProtectedRoutes>
            <ProposalText />
          </ProtectedRoutes>
        } />
        <Route path="/notification" element={
          <ProtectedRoutes>
            <Notification />
          </ProtectedRoutes>
        } />
        <Route path="/clientEmailTemplate" element={
          <ProtectedRoutes>
            <ClientEmailTemplate />
          </ProtectedRoutes>
        } />
        <Route path="/help" element={
          <ProtectedRoutes>
            <Help />
          </ProtectedRoutes>
        } />
        <Route path="/state-and-county-tax" element={
          <ProtectedRoutes>
            <Tax />
          </ProtectedRoutes>
        } />
        <Route path="/subscription-management" element={
          <ProtectedRoutes>
            <SubscriptionManagement />
          </ProtectedRoutes>
        } />
        <Route path="/repair-policy" element={
          <ProtectedRoutes>
            <RepairPolicy />
          </ProtectedRoutes>
        } />
      </Routes>
    </div>
  );
}

export default AppRoute;
